//
//
//
//
//

export default {
    name: 'error',
    data () {
        return {
            getLoginInfo () {
                let param = this.$route.query
                this.$http.get('/wxapi/index/wxcallback', { params: { code: param.code, state: param.state, store_id: param.store_id, inviter_id: param.inviter_id, registration_source: param.registration_source } }).then(response => {
                    if (response.code === 0) {
                        sessionStorage.setItem('x-token', response.data.token)
                        sessionStorage.setItem('nickname', response.data.nickname)
                        sessionStorage.setItem('tel', response.data.tel)
                        sessionStorage.setItem('headimgurl', response.data.headimgurl)
                        sessionStorage.setItem('id', response.data.id)
                        sessionStorage.setItem('store_name', response.data.store_name)
                        this.$store.dispatch('user/getUserInfo', {
                            id: response.data.id,
                            headimgurl: response.data.headimgurl,
                            store_name: response.data.store_name,
                            store_id: param.store_id,
                            tel: response.data.tel
                        })
                        this.$router.push({
                            path: '/home',
                            query: {
                                store_id: this.$route.query.store_id
                            }
                        })
                    }
                    if (response.code === 200002) {
                        this.$vux.toast.show({
                            text: '你的账号无法登陆～',
                            type: 'cancel'
                        })
                    }
                })
            }
        }
    },
    mounted () {
        console.log(this.$route)
        console.log('result: ', 'store_id' in this.$route.query)
        if (!('store_id' in this.$route.query)) {
            this.$vux.toast.show({
                text: '没有存在画苑，选择画苑再进入',
                type: 'cancel'
            })
        } else {
            if (!sessionStorage.getItem('x-token')) {
                if ('code' in this.$route.query) {
                    this.getLoginInfo()
                } else {
                    let url = '//wx.jiuyiyishu.com/wxapi/index/wxlogin?store_id=' + this.$route.query.store_id
                    // let url = '//testapi.jiuyiyishu.com/wxapi/index/wxlogin?store_id=' + this.$route.query.store_id
                    if ('inviter_id' in this.$route.query) {
                        url += '&inviter_id=' + this.$route.query.inviter_id
                    }
                    window.location.href = url
                }
            } else {
                this.$router.push({
                    path: '/home',
                    query: {
                        store_id: this.$route.query.store_id
                    }
                })
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/load/index.vue